import PageShell from "@/components/layout/PageShell";
import FAQAccordion from "@/components/shared/FAQAccordion";
import { FAQS_GENERAL, BRAND } from "@/lib/data";
import { Phone } from "lucide-react";

export default function FAQ() {
  return (
    <PageShell>
      <section className="bg-[#0B2545] text-white pt-16 md:pt-24 pb-14 md:pb-20" data-testid="faq-hero">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <div className="overline-light mb-6">Frequently asked questions</div>
          <h1 className="font-serif text-[9vw] md:text-[6vw] lg:text-[5vw] leading-[1.02] tracking-[-0.02em] text-white max-w-5xl">
            Everything you need to know before you book.
          </h1>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-white">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10">
          <FAQAccordion items={FAQS_GENERAL} testIdPrefix="faq-page" />
        </div>
      </section>

      <section className="py-20 md:py-24 bg-[#F5F7FA] border-t border-line">
        <div className="mx-auto max-w-[1600px] px-5 md:px-10 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <h2 className="font-serif text-3xl md:text-5xl leading-tight text-[#0B2545] max-w-2xl">
            Didn't find your answer? Call our team.
          </h2>
          <div>
            <a href={BRAND.phoneHref} className="btn-primary" data-testid="faq-call">
              <Phone className="h-4 w-4" strokeWidth={2} /> {BRAND.phone}
            </a>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
